import React, {useEffect, useMemo, useState} from 'react'
import {
  Dialog,
  DialogContent,
  Stack,
  IconButton,
  DialogTitle,
  Typography,
  TextField,
  Box,
  MenuItem,
  Select,
  Button,
  Checkbox,
  Grid
} from "@mui/material";
import _ from 'lodash';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';
import { rolePermissionsSelector, updateRolePermissions } from '../../../store/slices/rolePermissions';
import { convertArrayToDictionary } from '../../../common/utils';


const RolePermissionsEditDialog=({open=false, handleClose, selectedRow})=>{
    const [role, setRole] = useState([]);
     const { roles, rolePermissions } = useSelector(rolePermissionsSelector);
      const rolesDic = useMemo(()=>convertArrayToDictionary(roles, 'name'),[roles])
    const dispatch = useDispatch();
    const getPermission = (uiSectionId, roleId)=>{
            return _.filter(rolePermissions, (it)=>it.uiSectionId===uiSectionId&&it.roleId===roleId)
    }
    const getRoleId = (role)=>{
       return getPermission(selectedRow?.uiSectionId, rolesDic?.[role]?.roleId)?.[0]?.roleId 
    }
    
    useEffect(()=>{
      setRole((prev)=>([
        {roleId: getRoleId('User'), uiSectionId:selectedRow?.uiSectionId},
        {roleId: getRoleId('Admin'), uiSectionId:selectedRow?.uiSectionId}, 
        {roleId: getRoleId('Manager'), uiSectionId:selectedRow?.uiSectionId}
      ].filter(item=>item.roleId)
    ))
    },[])
    
  const handleRoleChange  = (e, role)=>{
    const isChecked = e.target.checked;
    
    const newItem = {
      roleId: rolesDic[role]?.roleId ,
      uiSectionId: selectedRow?.uiSectionId
    }
    setRole((prev)=>{
      if(isChecked){
        const exists = prev?.some((item)=>item.roleId===newItem.roleId&& item.uiSectionId===newItem.uiSectionId);
        return exists?prev:[...prev, newItem]
      }else{
        return prev.filter(item=>!(item.roleId===newItem.roleId&& item.uiSectionId===newItem.uiSectionId))
      }
    })
  }
  const onSave = ()=>{ 
    if(role.length>0){
      
      dispatch(updateRolePermissions({list:role}));
    }
    handleClose();
  }

    return(
        <Dialog open={open} onClose={handleClose} maxWidth="lg"  
                    PaperProps={{
                        sx: {
                          minWidth: '660px',
                        }
                      }}
                    >
                    <DialogTitle>
        
                        <Stack
                            direction="row"
                            spacing={2}
                            justifyContent="space-between"
                            alignItems="center"
                            // sx={{float:'right'}}
                        >
                          <Typography variant='h5'>Edit {selectedRow?.name} Permissions</Typography>
                            <IconButton color="secondary" onClick={handleClose}>
                                <CloseIcon fontSize="small" />
                            </IconButton>
        
                        </Stack>
                    </DialogTitle>
                    <DialogContent dividers sx={{paddingBottom:'24px'}}>
                      <Box>
                         {/* <Typography variant='h6'>Roles</Typography> */}
                         <Box sx={{'& .MuiBox-root':{
                           display:'flex',
                           alignItems:'center'
                         }}}>
                        <Box>
                          <Checkbox onChange={(e)=>handleRoleChange(e, 'User')} checked={role.some(r => r.roleId === rolesDic['User']?.roleId && r.uiSectionId === selectedRow?.uiSectionId)}/>
                          <Typography> User</Typography>
                        </Box>

                        <Box>
                          <Checkbox onChange={(e)=>handleRoleChange(e, 'Admin')} checked={role.some(r => r.roleId === rolesDic['Admin']?.roleId && r.uiSectionId === selectedRow?.uiSectionId)}/>
                          <Typography> Admin</Typography>
                        </Box>

                        <Box>
                          <Checkbox onChange={(e)=>handleRoleChange(e, 'Manager')} checked={role.some(r => r.roleId === rolesDic['Manager']?.roleId && r.uiSectionId === selectedRow?.uiSectionId)}/>
                          <Typography> Manager</Typography>
                        </Box>
                       </Box>
                      </Box>
                        {<Button variant='contained' color='primary' sx={{ mt: 1 }}  onClick={()=>onSave()}>Submit</Button>}
                    </DialogContent>
                </Dialog>
      )
}
export default RolePermissionsEditDialog;